import React from 'react'
import classes from './FlexInputs.module.scss'

interface FlexInputsProps {
  style?: React.CSSProperties
}

export const FlexInputs: React.FunctionComponent<FlexInputsProps> = ({
  children,
  style,
}) => (
  <div className={classes.flexInputs} style={style}>
    {children}
  </div>
)
